import { PopoverBody } from "react-bootstrap";
import { PopupOverlay } from "../../reactOL/overlays";
import { useBoundaries } from "../../../context/boundary";
import MileageTable from "./MileageTable";
import MeasurementToggle from "./MeaurumentToggle";
import OverlayHeader from "./OverlayHeader";
import CopyUrlButton from "./CopyUrlButton";
import { useLocation, useParams } from "react-router-dom";
import { useEffect } from "react";
import { useMap } from "../../../context/map";
import { getCenter } from "ol/extent";

interface BoundaryPopUpOverlayProps {
  year?: number;
}

const BoundaryPopUpOverlay = ({ year }: BoundaryPopUpOverlayProps) => {
  const { overlayCoordinate } = useBoundaries();
  const { boundary: urlBoundary } = useParams();
  const { state } = useLocation();
  const { boundaries, setSelectedBoundary, setOverlayCoordinate } =
    useBoundaries();
  const { map } = useMap();

  // autofit to the overlay
  useEffect(() => {
    if (!urlBoundary) return;

    const shouldAutoFocus = state?.autoFocus !== false;
    const lowerCaseUrl = urlBoundary.toLowerCase();
    const matchingBoundary = boundaries.find(
      (b) => b.urlTag.toLowerCase() === lowerCaseUrl,
    );

    if (!matchingBoundary) return;

    if (shouldAutoFocus) {
      map
        ?.getView()
        .fit(matchingBoundary.envelope, { padding: [100, 100, 100, 100] });
      setOverlayCoordinate(getCenter(matchingBoundary.envelope));
      setSelectedBoundary(matchingBoundary);
    }
  }, [
    urlBoundary,
    boundaries,
    map,
    setSelectedBoundary,
    setOverlayCoordinate,
    state,
  ]);

  return (
    <PopupOverlay width="300px" coordinate={overlayCoordinate} placement="top">
      <PopoverBody className="text-center p-0" style={{ borderRadius: 7 }}>
        <OverlayHeader />
        <MeasurementToggle />
        <MileageTable year={year} />
        <CopyUrlButton />
      </PopoverBody>
    </PopupOverlay>
  );
};

export default BoundaryPopUpOverlay;
